/**
 * 이미지 소스 URL 결정 함수
 * 다양한 상태와 조건에 따라 최종적으로 사용할 이미지 URL을 결정
 */ export var resolveImageSource = function(options) {
    var mainImgError = options.mainImgError, fallbackSrc = options.fallbackSrc, internalBlobUrl = options.internalBlobUrl, imageBlob = options.imageBlob, src = options.src, processImageUrl = options.processImageUrl;
    // 메인 이미지 오류 시 대체 이미지 사용
    if (mainImgError) {
        return fallbackSrc || '';
    }
    // Blob 객체에서 생성한 내부 URL 우선 사용
    if (internalBlobUrl && imageBlob) {
        return internalBlobUrl;
    }
    // src가 유효하고 placeholder가 아닌 경우 URL 가공 처리
    if (src && src !== '_placeholder_') {
        return processImageUrl(src);
    }
    // 그 외의 경우 대체 이미지 사용
    return fallbackSrc || '';
};
/**
 * 대체 이미지 경로 생성 함수
 * 환경이나 테마에 따라 적절한 대체 이미지 경로 반환
 */ export var getDefaultImagePath = function(options) {
    var _ref = options || {}, _ref_theme = _ref.theme, theme = _ref_theme === void 0 ? 'light' : _ref_theme, _ref_type = _ref.type, type = _ref_type === void 0 ? 'general' : _ref_type;
    // Inline SVG placeholders to avoid dependency on /public assets in Storybook/Bazel
    var colorBg = theme === 'dark' ? '#111827' : '#e5e7eb';
    var colorFg = theme === 'dark' ? '#374151' : '#9ca3af';
    var svg = function() {
        switch(type){
            case 'profile':
                return '<svg xmlns="http://www.w3.org/2000/svg" width="320" height="180" viewBox="0 0 320 180">\n          <rect width="320" height="180" fill="'.concat(colorBg, '"/>\n          <circle cx="160" cy="72" r="32" fill="').concat(colorFg, '"/>\n          <rect x="80" y="120" width="160" height="20" rx="10" fill="#cbd5e1"/>\n        </svg>');
            case 'post':
                return '<svg xmlns="http://www.w3.org/2000/svg" width="320" height="180" viewBox="0 0 320 180">\n          <rect width="320" height="180" fill="'.concat(colorBg, '"/>\n          <rect x="24" y="24" width="272" height="132" fill="').concat(colorFg, '"/>\n        </svg>');
            case 'general':
            default:
                return '<svg xmlns="http://www.w3.org/2000/svg" width="320" height="180" viewBox="0 0 320 180">\n          <rect width="320" height="180" fill="'.concat(colorBg, '"/>\n        </svg>');
        }
    }();
    return "data:image/svg+xml;utf8,".concat(encodeURIComponent(svg));
};
